import React, { useState, useContext } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import AuthContext from "../../context/AuthContext";

const TagInfo = (value, text) => {
  return (
    <>
      {value && (
        <p className="mb-2">
          <span className="text-[#988ec7] font-bold">{text}</span>
          <span className=" text-[#1B254B]">
          {" : " + value}

          </span>
        </p>
      )}
    </>
  );
};

export default function Tag({ tags, title }) {
  const [isOpen, setIsOpen] = useState(false);
  const { handleDelete } = useContext(AuthContext);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="max-w-md mx-auto my-8 ">
      <div className="border border-gray-300 rounded">
        <div
          className="flex items-center justify-between p-4 cursor-pointer"
          onClick={() => toggleAccordion()}
        >
          <h2 className=" text-[#1B254B] text-lg font-semibold">
            {title}
          </h2>
          <IoIosArrowDown
            className={` text-gray-300 w-4 h-4 transition-transform transform ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </div>
        {isOpen && (
          <div className=" m-2">
            <div key={tags} className="flex border-b-2 justify-between">
                <div className="text-base">
                  {TagInfo(tags.count, "Click")}
                  {TagInfo(tags.tag, `Tag  `)}
                  {TagInfo(tags.id, "Id")}
                  {TagInfo(tags.className, "className")}
                  {TagInfo(tags.Disabled, "Disabled")}
                  {TagInfo(tags.name, "Name")}
                  {TagInfo(tags.text, "Text")}
                  {TagInfo(tags.type, "Type")}
                  {tags.href && TagInfo(tags.href, "Redirect to")}
                  {tags.form >= 0 && tags.form != null && TagInfo(tags.form + 1, "Form")}
                </div>
                <div className="flex justify-end gap-1">
                <MdDelete
                  onClick={() => {
                    setIsOpen(false);
                    return handleDelete(tags._id);
                  }}
                  className="cursor-default text-lg text-[#dc444490] hover:text-[#d15555]"
                />
                </div>
              </div>
          </div>
        )}
      </div>
    </div>
  );
}
